import { PlayAudio } from '@core/types/gateways'

export const play: PlayAudio = async ({ filename }) => {
  const audio = new Audio(filename)
  await audio.play()
}
